/**
 * The ids AppShell's markup carries that code outside it waits on (the proof
 * harness's readiness, s5 r2 CR-8). AppShell renders these exact values, so a
 * rename here moves both together.
 */

/** The shell's content area. */
export const APPSHELL_CONTENT_TESTID = "appshell-content";
/**
 * The content area of a COMPOSE window with the Assistant on (s6): the chat
 * only, under the header, with no switch row.
 */
export const APPSHELL_COMPOSE_TESTID = "appshell-compose-content";
/** The Assistant-on header (the shared "ora Work Simplified" bar). */
export const APPSHELL_ASSISTANT_HEADER_TESTID = "appshell-assistant-header";
/** The accessible name of the Needs you | Assistant strip (its tablist). */
export const APPSHELL_SWITCH_LABEL = "Work Simplified";
